// import React, { useState, useEffect } from "react";
// import { Box, Paper, Typography, Tooltip } from "@mui/material";
// import PictureOne from "../../assets/Frame 35083 (1).png";
// import PictureTwo from "../../assets/Frame 35083 (2).png";
// import PictureThree from "../../assets/Frame 35083.png";
// import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
// import PersonOffIcon from "@mui/icons-material/PersonOff";
// import Grid from "@mui/material/Grid";
// import Leadmanagement from "./LeadsPart/Leadmanagement";
// import ReferralsPoints from "./ReferralsPart/ReferralsPoints";
// import ClientComponent from "./ClientsPart/ClientComponent";
// import PartnersComponent from "./PartnersComponent";
// import DroppedInt from "./DroppedInt";
// import Chartdata from "./Chartdata";
// import axios from "axios";
// // import { toast } from "react-toastify";
// import { useAuth } from "../../Context/AuthContext";
// import { Link } from "react-router-dom";

// const apiUrl = process.env.REACT_APP_API_REST_URL;

// const Dashboard = () => {
//   const { token } = useAuth();
//   const [dataValue, setDataValue] = useState(null);
//   const roleId = sessionStorage.getItem("roleId");
//   console.log("roleid", typeof roleId);
//   const [activeComponent, setActiveComponent] = useState(null);

//   const handleDashboard = async (data) => {
//     const headers = {
//       "x-access-token": token,
//     };
//     try {
//       const updateResponse = await axios.get(
//         `${apiUrl}/CCE/api/v1/referalEngine/stats`,
//         { headers }
//       );
//       console.log("'asdede result", updateResponse);
//       const resultData = updateResponse.data?.data;
//       console.log("Responseee:", updateResponse);
//       setDataValue(resultData);
//     } catch (error) {
//       console.error("Error updating user:", error.message);
//     }
//   };

//   useEffect(() => {
//     handleDashboard();
//   }, []);

//   // const handleComponentChange = (component, index) => {
//   //   console.log("component", component);
//   //   // setActiveComponent(component);
//   //   setSelectedIcon(index);
//   //   setSelectedSection("top");
//   // };

//   return (
//     <Box sx={styles.main_container}>
//       <Box sx={{ width: "100%" }}>
//         <Paper sx={styles.dashboard_paper}>
//           <h3>Dashboard</h3>
//         </Paper>
//         <Box sx={{ display: "flex" }}>
//           <Paper sx={{ margin: "10px", padding: "12px" }}>
//             <Grid container spacing={2}>
//               <Grid item xs={4}>
//                 <Link
//                   to="/employeedashboard/partners"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Paper
//                     sx={{
//                       margin: "5px",
//                       padding: "8px",
//                       border: "1px solid blue",
//                       textAlign: "center",
//                       cursor: "pointer",
//                     }}
//                     // onClick={() => handleComponentChange("Partners", 6)}
//                   >
//                     <Tooltip title="Total number of approved Partners.">
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "center",
//                           alignItems: "center",
//                           textAlign: "center",
//                         }}
//                       >
//                         <Box>
//                           {/* Uncomment and customize as needed */}
//                           {/* <Box sx={styles.partners_logo}>
//             <PeopleOutlineIcon sx={{ color: "#fff" }} />
//         </Box> */}
//                         </Box>

//                         <Box sx={{ textAlign: "center" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "28px", fontWeight: 700 }}
//                           >
//                             {dataValue?.TotalPartners
//                               ? dataValue?.TotalPartners
//                               : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Partners
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Tooltip>
//                   </Paper>
//                 </Link>
//               </Grid>

//               <Grid item xs={4}>
//                 <Paper
//                   sx={{
//                     margin: "5px",
//                     padding: "8px",
//                     border: "1px solid blue",
//                     textAlign: "center",
//                   }}
//                 >
//                   <Tooltip title="Total number of Referrals from Partners.">
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         textAlign: "center",
//                       }}
//                     >
//                       <Box>
//                         <Typography
//                           variant="h6"
//                           sx={{ fontSize: "28px", fontWeight: 700 }}
//                         >
//                           {dataValue?.referralCount
//                             ? dataValue?.referralCount
//                             : 0}
//                         </Typography>
//                         <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                           Partner Referrals
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Tooltip>
//                 </Paper>
//               </Grid>

//               {roleId == 1 && (
//                 <Grid item xs={4}>
//                   <Link
//                     to="/employeedashboard/wealth-advisors"
//                     style={{ textDecoration: "none" }}
//                   >
//                     <Paper
//                       sx={{
//                         margin: "5px",
//                         padding: "8px",
//                         border: "1px solid green",
//                         textAlign: "center",
//                         display: "flex",
//                         justifyContent: "center", // Center horizontally
//                         alignItems: "center", // Center vertically
//                         cursor: "pointer",
//                       }}
//                       // onClick={() => handleComponentChange("WealthAdvisors", 8)}
//                     >
//                       <Tooltip title="Count of relationship managers">
//                         <Box
//                           sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "28px", fontWeight: 700 }}
//                           >
//                             {dataValue?.rms ? dataValue?.rms : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Wealth Advisors
//                           </Typography>
//                         </Box>
//                       </Tooltip>
//                     </Paper>
//                   </Link>
//                 </Grid>
//               )}

//               {/* -------------------- */}

//               <Grid item xs={12}>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     marginBottom: "0px",
//                     textAlign: "left",
//                     fontSize: "1rem",
//                   }}
//                 >
//                   Referral Stats
//                 </Typography>
//               </Grid>

//               <Grid item xs={4}>
//                 <Link
//                   to="/employeedashboard/leads"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Paper
//                     sx={{
//                       margin: "5px",
//                       padding: "10px",
//                       border: "1px solid blue",
//                       cursor: "pointer",
//                     }}
//                     // onClick={() => handleComponentChange("Leads", 3)}
//                   >
//                     <Tooltip title="Count of Leads converted from Partner Referrals.">
//                       <Box sx={{ display: "flex" }}>
//                         <Box>
//                           <img
//                             src={PictureThree}
//                             alt="Logo Two"
//                             width="42px"
//                             height="42px"
//                             style={{ margin: "10px" }}
//                           />
//                         </Box>

//                         <Box sx={{ textAlign: "left" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "28px", fontWeight: 700 }}
//                           >
//                             {dataValue?.referralLeadCount
//                               ? dataValue?.referralLeadCount
//                               : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Leads
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Tooltip>
//                   </Paper>
//                 </Link>
//               </Grid>

//               <Grid item xs={4}>
//                 <Link
//                   to="/employeedashboard/clients"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Paper
//                     sx={{
//                       margin: "5px",
//                       padding: "10px",
//                       border: "1px solid blue",
//                       cursor: "pointer",
//                     }}
//                     // onClick={() => handleComponentChange("Clients", 4)}
//                   >
//                     <Tooltip title="Total number of Clients">
//                       <Box sx={{ display: "flex" }}>
//                         <Box>
//                           <img
//                             src={PictureOne}
//                             alt="Logo Three"
//                             width="42px"
//                             height="42px"
//                             style={{ margin: "10px" }}
//                           />
//                         </Box>

//                         <Box sx={{ textAlign: "left" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "28px", fontWeight: 700 }}
//                           >
//                             {dataValue?.referralClientCount
//                               ? dataValue?.referralClientCount
//                               : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Clients
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Tooltip>
//                   </Paper>
//                 </Link>
//               </Grid>

//               <Grid item xs={4}>
//                 <Link
//                   to="/employeedashboard/dropped-leads"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Paper
//                     sx={{
//                       margin: "5px",
//                       padding: "10px",
//                       border: "1px solid blue",
//                       cursor: "pointer",
//                     }}
//                     // onClick={() => handleComponentChange("Drops", 5)}
//                   >
//                     <Tooltip title="Count of Referrals or Leads that got dropped.">
//                       <Box sx={{ display: "flex" }}>
//                         <Box>
//                           <Box sx={styles.partners_logo}>
//                             <PersonOffIcon sx={{ color: "#fff" }} />
//                           </Box>
//                         </Box>

//                         <Box sx={{ textAlign: "left" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "28px", fontWeight: 700 }}
//                           >
//                             {dataValue?.referralDropCount
//                               ? dataValue?.referralDropCount
//                               : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Drops
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Tooltip>
//                   </Paper>
//                 </Link>
//               </Grid>
//               <Grid item xs={4}>
//                 <Link
//                   to="/employeedashboard/referrals"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Paper
//                     sx={{
//                       margin: "5px",
//                       padding: "10px",
//                       border: "1px solid blue",
//                       cursor: "pointer",
//                     }}
//                     // onClick={() => handleComponentChange("PendingConversions", 1)}
//                   >
//                     <Tooltip title="Count of Referrals that are pending.">
//                       <Box sx={{ display: "flex" }}>
//                         <Box>
//                           {/* <Box sx={styles.partners_logo}>
//               <PersonOffIcon sx={{ color: "#fff" }} />
//             </Box> */}
//                         </Box>

//                         <Box sx={{ textAlign: "center" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "24px", fontWeight: 700 }}
//                           >
//                             {dataValue?.referralPendingCount
//                               ? dataValue?.referralPendingCount
//                               : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Pending Conversions
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Tooltip>
//                   </Paper>
//                 </Link>
//               </Grid>

//               {/* ----------------------- */}
//               <Grid item xs={12}>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     marginBottom: "0px",
//                     textAlign: "left",
//                     fontSize: "1rem",
//                   }}
//                 >
//                   Self Sourced
//                 </Typography>
//               </Grid>

//               <Grid item xs={4}>
//                 <Link
//                   to="/employeedashboard/leads"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Paper
//                     sx={{
//                       margin: "5px",
//                       padding: "10px",
//                       border: "1px solid green",
//                       cursor: "pointer",
//                     }}
//                     // onClick={() => handleComponentChange("Leads", 3)}
//                   >
//                     <Tooltip title="Total number of Leads generated.">
//                       <Box sx={{ display: "flex" }}>
//                         <Box>
//                           <img
//                             src={PictureThree}
//                             alt="Logo Two"
//                             width="42px"
//                             height="42px"
//                             style={{ margin: "10px" }}
//                           />
//                         </Box>

//                         <Box sx={{ textAlign: "left" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "28px", fontWeight: 700 }}
//                           >
//                             {dataValue?.leadCount ? dataValue?.leadCount : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Leads
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Tooltip>
//                   </Paper>
//                 </Link>
//               </Grid>

//               <Grid item xs={4}>
//                 <Link
//                   to="/employeedashboard/clients"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Paper
//                     sx={{
//                       margin: "5px",
//                       padding: "10px",
//                       border: "1px solid green",
//                       cursor: "pointer",
//                     }}
//                     // onClick={() => handleComponentChange("Clients", 4)}
//                   >
//                     <Tooltip title="Total number of Clients generated.">
//                       <Box sx={{ display: "flex" }}>
//                         <Box>
//                           <img
//                             src={PictureOne}
//                             alt="Logo Three"
//                             width="42px"
//                             height="42px"
//                             style={{ margin: "10px" }}
//                           />
//                         </Box>

//                         <Box sx={{ textAlign: "left" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "28px", fontWeight: 700 }}
//                           >
//                             {dataValue?.clientCount
//                               ? dataValue?.clientCount
//                               : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Clients
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Tooltip>
//                   </Paper>
//                 </Link>
//               </Grid>

//               <Grid item xs={4}>
//                 <Link
//                   to="/employeedashboard/dropped-leads"
//                   style={{ textDecoration: "none" }}
//                 >
//                   <Paper
//                     sx={{
//                       margin: "5px",
//                       padding: "10px",
//                       border: "1px solid green",
//                       cursor: "pointer",
//                     }}
//                     // onClick={() => handleComponentChange("Drops", 5)}
//                   >
//                     <Tooltip title="Total number of generated Leads dropped.">
//                       <Box sx={{ display: "flex" }}>
//                         <Box>
//                           <Box sx={styles.partners_logo}>
//                             <PersonOffIcon sx={{ color: "#fff" }} />
//                           </Box>
//                         </Box>

//                         <Box sx={{ textAlign: "left" }}>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontSize: "28px", fontWeight: 700 }}
//                           >
//                             {dataValue?.leadDropCount
//                               ? dataValue?.leadDropCount
//                               : 0}
//                           </Typography>
//                           <Typography variant="h6" sx={{ fontSize: "16px" }}>
//                             Drops
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Tooltip>
//                   </Paper>
//                 </Link>
//               </Grid>
//             </Grid>
//           </Paper>

//           <Paper sx={{ flex: 1, margin: "10px", padding: "12px" }}>
//             {/* -----------------------ChartData------------------------- */}
//             <Box sx={{ margin: "15px" }}>
//               <Chartdata />
//             </Box>
//           </Paper>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Dashboard;

// const styles = {
//   main_container: {
//     display: "flex",
//     justifyContent: "space-between",
//     height: "91vh",
//     padding: "0px",
//     margin: "0px",
//     marginTop: "-25px",
//     background: "#f2f2f2",
//     // border:"1px solid red"
//   },
//   dashboard_paper: {
//     height: "40px",
//     display: "flex",
//     alignItems: "center",
//     paddingLeft: "15px",
//   },
//   logo_card: {
//     width: "18%",
//     height: "60px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "left",
//     borderRadius: "12px",
//   },

//   partners_logo: {
//     width: 46,
//     height: 46,
//     background: "#66ccff",
//     borderRadius: "50%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     margin: "10px",
//   },
// };
import WhatshotIcon from "@mui/icons-material/Whatshot";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import PersonIcon from "@mui/icons-material/Person";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ContentPasteOffIcon from "@mui/icons-material/ContentPasteOff";
import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Tooltip,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import PictureOne from "../../assets/Frame 35083 (1).png";
import PictureTwo from "../../assets/Frame 35083 (2).png";
import PictureThree from "../../assets/Frame 35083.png";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import Grid from "@mui/material/Grid";
import Leadmanagement from "./LeadsPart/Leadmanagement";
import ReferralsPoints from "./ReferralsPart/ReferralsPoints";
import ClientComponent from "./ClientsPart/ClientComponent";
import PartnersComponent from "./PartnersComponent";
import DroppedInt from "./DroppedInt";
import Chartdata from "./Chartdata";
import axios from "axios";
// import { toast } from "react-toastify";
import { useAuth } from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const apiUrl = process.env.REACT_APP_API_REST_URL;
const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};
const Dashboard = () => {
  const { token } = useAuth();
  const [dataValue, setDataValue] = useState(null);
  const roleId = +sessionStorage.getItem("roleId");
  const isOperations = roleId === 1 || roleId === 7;
  const [loading, setLoading] = useState(true);
  const [allinteractions, setAllinteractions] = useState([]);
  const [leadstatustypes, setLeadStatustypes] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [referrals, setReferrals] = useState([]);
  const [dashboardCounts, setDashboardCounts] = useState("");
  const [estPortfolioTypes, setEstpostfolioTypes] = useState([]);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  // console.log("roleid", typeof roleId);
  const [followuplocationtype, setfollowuplocationtype] = useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (path, options = {}) => {
    setAnchorEl(null);
    if (path) navigate(path, options);
  };
  const formatDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "-";
    }
  };
  const formatDateTime = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return (
        date.toLocaleDateString("en-GB") +
        " " +
        date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      );
    } else {
      return "-";
    }
  };
  const getleadstatustypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/lead_status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setLeadStatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const handleDashboard = async (data) => {
    const headers = {
      "x-access-token": token,
    };
    try {
      const updateResponse = await axios.get(
        `${apiUrl}/CCE/api/v1/referalEngine/stats`,
        { headers }
      );
      console.log("'asdede result", updateResponse);
      const resultData = updateResponse.data?.data;
      console.log("Responseee:", updateResponse);
      setDataValue(resultData);
    } catch (error) {
      console.error("Error updating user:", error.message);
    }
  };
  const fetchDashboardCounts = async () => {
    const headers = {
      "x-access-token": token,
    };
    try {
      const response = await axios.get(
        `${apiUrl}/CCE/api/v1/userEngine/getDashboardCount`,
        { headers }
      );
      if (response.data.status === "SUCCESS") {
        setDashboardCounts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard counts:", error);
    }
  };
  const fetchInteractions = async () => {
    setLoading(true);
    const headers = {
      "x-access-token": token,
    };
    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/fetchReferralInteraction`,
        { userId: "all" },
        { headers }
      );
      console.log("respo", response);
      setAllinteractions(response?.data.response || []);
    } catch (error) {
      console.error("Error fetching graph data:", error.message);
    }
    setLoading(false);
  };
  const fetchReferrals = async () => {
    setLoading(true);
    const headers = {
      "x-access-token": token,
    };
    try {
      const apiResponse = await axios.get(
        `${apiUrl}/CCE/api/v1/referalEngine/getReferral/referral`,
        { headers }
      );

      if (apiResponse) {
        const apiData = apiResponse?.data?.response;
        setReferrals(apiData);
      }

      console.log("referral api", apiResponse);
    } catch (error) {
      console.error("Error fetching graph data:", error.message);
    }
    setLoading(false);
  };
  const getEstPortfolioData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/estimated_annual_income`;
      const response = await axios.get(url, {});
      setEstpostfolioTypes(response.data.response);
      console.log(response.data.response, "annualincometypes");
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getleadstatustypeData();
    handleDashboard();
    fetchInteractions();
    fetchReferrals();
    fetchDashboardCounts();
    getEstPortfolioData();
  }, []);
  const filteredInteractions = Object.values(
    allinteractions
      .filter((interaction) => interaction.status === 23)
      .reduce((latest, current) => {
        const clientId = current.clientId;

        // If we haven't seen this client yet OR this is a newer follow-up than what we have
        if (
          !latest[clientId] ||
          new Date(current.followup_date_n_time) >
            new Date(latest[clientId].followup_date_n_time)
        ) {
          latest[clientId] = current;
        }

        return latest;
      }, {})
  ).sort((a, b) => {
    return new Date(a.followup_date_n_time) - new Date(b.followup_date_n_time);
  });
  const handleNameClick = (leadName, interactions, rowData) => {
    navigate("/employeedashboard/leads/view", {
      state: {
        leadId: rowData.clientId,
        from: "/employeedashboard",
      },
    });
  };
  const handleReferralClick = (leadName, interactions, rowData) => {
    // console.log("leadname", leadName);
    // console.log("leadData", rowData);
    navigate("/employeedashboard/referrals/view", {
      state: {
        leadId: rowData.id,
        from: "/employeedashboard",
      },
    });
  };
  const getFollowupStatement = (interaction, followupTypeMap) => {
    const followupDate = new Date(interaction.followup_date_n_time);
    const now = new Date();
    const isToday = followupDate.toDateString() === now.toDateString();
    const isTomorrow =
      followupDate.toDateString() ===
      new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      ).toDateString();

    const time = followupDate.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    let datePart;
    if (isToday) {
      datePart = `today at ${time}`;
    } else if (isTomorrow) {
      datePart = `tomorrow at ${time}`;
    } else {
      datePart = `on ${followupDate.toLocaleDateString("en-GB")} ${time}`;
    }

    const name = interaction.clientName;
    const locationType = interaction.followup_location_type_description;
    const location = interaction.followup_location;

    let beforeName = "";
    let afterName = "";

    switch (interaction.followup_type) {
      case 33:
        beforeName = "Send email to ";
        afterName = ` ${datePart}.`;
        break;
      case 34:
        beforeName = "Telephonic call with ";
        afterName = ` ${datePart}.`;
        break;
      case 35:
        beforeName = "Video call with ";
        afterName = ` ${datePart}.`;
        break;
      case 36:
        beforeName = "In Person call with ";
        afterName =
          locationType === "Other" || locationType === "other"
            ? ` ${datePart} at ${location}.`
            : ` ${datePart} at ${locationType}.`;
        break;
      case 37:
        beforeName = "Whatsapp ";
        afterName = ` ${datePart}.`;
        break;
      default:
        beforeName = "Follow up with ";
        afterName = ` ${datePart}.`;
    }

    let userPart = "";
    if ((roleId === 1 || roleId === 6) && interaction.userName) {
      userPart = ` (${interaction.userName})`;
    }

    return {
      beforeName,
      name,
      afterName,
      userPart,
      interaction,
    };
  };

  const generateFollowupStatements = () => {
    const now = new Date();
    const oneWeekFromNow = new Date();
    oneWeekFromNow.setDate(now.getDate() + 7);

    const futureFollowups = allinteractions.filter((interaction) => {
      const followupDate = new Date(interaction.followup_date_n_time);
      return (
        interaction.followup_date_n_time &&
        followupDate > now &&
        followupDate <= oneWeekFromNow
      );
    });
    futureFollowups.sort((a, b) => {
      const dateA = new Date(a.followup_date_n_time);
      const dateB = new Date(b.followup_date_n_time);
      return dateA - dateB;
    });
    const statements = futureFollowups.map((interaction) =>
      getFollowupStatement(interaction, followuplocationtype)
    );
    return statements;
  };

  // const handleComponentChange = (component, index) => {
  //   console.log("component", component);
  //   // setActiveComponent(component);
  //   setSelectedIcon(index);
  //   setSelectedSection("top");
  // };
  const Referralcolumns = [
    {
      field: "referralName",
      headerName: "Referral Name",
      renderCell: (params) => (
        <div
          title={`${params.row.firstname} ${params.row.lastname}`}
          onClick={() =>
            handleReferralClick(
              `${params.row.firstname} ${params.row.lastname}`,
              params.row.interactionDetails,
              params.row
            )
          }
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {params.row.firstname} {params.row.lastname}
        </div>
      ),
      width: 160,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    ...(roleId === "1" || roleId === "6"
      ? [
          {
            field: "managerName",
            headerName: "Wealth Advisor",
            width: 160,
            headerClassName: "boldHeader",
            headerAlign: "center",
            cellClassName: "centerAlign",
          },
        ]
      : []),
    {
      field: "created_date",
      headerName: "Added On",
      valueFormatter: (params) => formatDateString(params.value),
      width: 140,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "sourceOfReferral",
      headerName: "Source",
      width: 160,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
  ];

  const Columns = [
    {
      field: "clientName",
      headerName: "Name",
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => (
        <div
          title={`${params.value}`}
          onClick={() =>
            handleNameClick(
              `${params.row.firstname} ${params.row.lastname}`,
              params.row.interactionDetails,
              params.row
            )
          }
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
            //   whiteSpace: "nowrap",
            //   overflow: "hidden",
            //   textOverflow: "ellipsis",
            //   maxWidth: "140px",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "followup_date_n_time",
      headerName: "Follow Up Date & Time",
      valueFormatter: (params) => formatDateTime(params.value),
      width: 180,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "lead_status",
      headerName: "Lead Status",
      width: 170,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => (
        <div>
          {
            leadstatustypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
    {
      field: "estimated_portfolio_range",
      headerName: "Est. Portfolio Value",
      width: 150,
      headerAlign: "center",
      cellClassName: "centerAlign",
      renderCell: (params) => {
        const matched = estPortfolioTypes.find(
          (item) => item.id === params.value
        );
        return <span>{matched ? matched.masterValueDesc : "-"}</span>;
      },
    },
  ];
  return (
    <Box sx={styles.main_container}>
      <Box sx={{ width: "100%" }}>
        <Paper sx={styles.dashboard_paper}>
          <h3>Dashboard</h3>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              p: 1,
              justifyContent: "flex-end",
              width: "50%",
              marginLeft: "auto",
            }}
          >
            {isOperations && (
              <Button
                variant="contained"
                onClick={() =>
                  navigate("/employeedashboard/client-onb-kyc", {
                    state: { from: "/employeedashboard" },
                  })
                }
                sx={{
                  // width: "80px",
                  mr: 1,
                  fontSize: "11px",
                  backgroundColor: "#002C51",
                  color: "white",
                  textTransform: "none",
                  "&:hover": {
                    background: "#002C51",
                  },
                }}
              >
                Client Onboarding KYC
              </Button>
            )}
            <>
              <Button
                variant="contained"
                onClick={handleClick}
                sx={{
                  width: "80px",
                  fontSize: "11px",
                  backgroundColor: "#002C51",
                  color: "white",
                  textTransform: "none",
                  "&:hover": {
                    background: "#002C51",
                  },
                }}
              >
                Add
                <KeyboardArrowDownIcon sx={{ fontSize: 16, ml: 0.5 }} />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose()}
                PaperProps={{
                  sx: {
                    backgroundColor: "white",
                    color: "black",
                    mt: 1,
                    borderRadius: 1,
                  },
                }}
              >
                <MenuItem
                  onClick={() =>
                    handleClose("/employeedashboard/referrals/add", {
                      state: { from: "/employeedashboard" },
                    })
                  }
                >
                  Referral
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleClose("/employeedashboard/leads/add", {
                      state: { from: "/employeedashboard" },
                    })
                  }
                >
                  Lead
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    handleClose("/employeedashboard/clients/add", {
                      state: { from: "/employeedashboard" },
                    })
                  }
                >
                  Client
                </MenuItem>
              </Menu>
            </>
          </Box>
        </Paper>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gridTemplateRows: "auto 1fr",
            gap: 2,
            padding: 2,
            minHeight: "590px",
          }}
        >
          <Paper sx={{ padding: 2 }}>
            <Box sx={{ display: "flex", textAlign: "left" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  minWidth: 190,
                }}
              >
                <Typography sx={{ fontSize: "17px" }}>
                  Leads in pipeline:
                </Typography>
                <strong style={{ fontSize: "20px" }}>
                  {dashboardCounts.leadsCount}
                </strong>
              </Box>

              <Box sx={{ display: "flex", gap: 2, ml: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <WhatshotIcon color="error" sx={{ fontSize: 18 }} />
                  <Typography sx={{ fontSize: "13px" }}>
                    {dashboardCounts.hotLeadsCount} Hot
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <WbSunnyIcon color="warning" sx={{ fontSize: 18 }} />
                  <Typography sx={{ fontSize: "13px" }}>
                    {dashboardCounts.warmLeadsCount} Warm
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <AcUnitIcon color="info" sx={{ fontSize: 18 }} />
                  <Typography sx={{ fontSize: "13px" }}>
                    {dashboardCounts.coldLeadsCount} Cold
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: "flex", textAlign: "left", mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  minWidth: 190,
                }}
              >
                <Typography sx={{ fontSize: "17px" }}>
                  Active clients:
                </Typography>
                <strong style={{ fontSize: "20px" }}>
                  {dashboardCounts.clientsCount}
                </strong>
              </Box>
              <Box sx={{ display: "flex", gap: 2, ml: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PersonIcon color="success" sx={{ fontSize: 18 }} />
                  <Typography sx={{ fontSize: "13px" }}>
                    {dashboardCounts.thisMonthClientsCount} This month
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ContentPasteOffIcon sx={{ fontSize: 18 }} />
                  <Typography sx={{ fontSize: "13px" }}>
                    {dashboardCounts.clientsKycPendingCount} KYC details pending
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: "flex", textAlign: "left", mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  minWidth: 190,
                }}
              >
                <Typography sx={{ fontSize: "17px" }}>
                  Referrals assigned:
                </Typography>
                <strong style={{ fontSize: "20px" }}>
                  {dashboardCounts.referralsCount}
                </strong>
              </Box>
              <Box sx={{ display: "flex", gap: 2, ml: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <PendingActionsIcon sx={{ fontSize: 18 }} />
                  <Typography sx={{ fontSize: "13px" }}>
                    {dashboardCounts.notContactedReferralsCount} Not contacted
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <PersonOffIcon sx={{ fontSize: 18 }} />
                  <Typography sx={{ fontSize: "13px" }}>
                    {dashboardCounts.droppedReferralsCount} Dropped
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
          <Paper
            sx={{
              padding: 2,
              height: "150px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              style={{
                textAlign: "left",
                fontSize: "17px",
                fontWeight: "bold",
                color: "red",
              }}
            >
              Upcoming follow ups
            </Typography>
            <Box
              sx={{
                overflowY: "auto",
                flex: 1,
                pr: 1,
              }}
            >
              {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
                  <CircularProgress size={30} />
                </Box>
              ) : generateFollowupStatements().length > 0 ? (
                generateFollowupStatements().map((statement, index) => (
                  <Typography
                    key={index}
                    variant="body2"
                    style={{ textAlign: "left", marginBottom: 5 }}
                  >
                    {`${index + 1}. `}
                    {statement.beforeName}
                    <span
                      style={{
                        color: "blue",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleNameClick(
                          statement.name,
                          statement.interaction.interactions,
                          statement.interaction
                        )
                      }
                    >
                      {statement.name}
                    </span>
                    {statement.afterName}
                    {statement.userPart && (
                      <span style={{ color: "grey" }}>
                        {statement.userPart}
                      </span>
                    )}
                  </Typography>
                ))
              ) : (
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", color: "text.secondary", my: 3 }}
                >
                  No upcoming follow ups.
                </Typography>
              )}
            </Box>
          </Paper>
          <Paper sx={{ padding: 2 }}>
            <Typography
              style={{
                textAlign: "left",
                fontSize: "17px",
              }}
            >
              Referrals to be contacted
            </Typography>
            <div style={{ height: 340, width: "100%", overflow: "auto" }}>
              <DataGrid
                loading={loading}
                // rowHeight={40}
                // headerHeight={40}
                rows={referrals}
                columns={Referralcolumns}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                sx={{
                  ...sxStyles.boldHeader, // Spread existing styles
                  fontSize: "13px",
                  "& .MuiDataGrid-columnHeaders": {
                    fontWeight: "bold",
                    textAlign: "center",
                    // minHeight: "40px !important",
                    // maxHeight: "40px !important",
                  },
                  "& .MuiDataGrid-cell": {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                }}
              />
            </div>
          </Paper>

          <Paper sx={{ padding: 2 }}>
            <Typography
              style={{
                textAlign: "left",
                fontSize: "17px",
              }}
            >
              Pending interactions
            </Typography>
            <div style={{ height: 340, width: "100%", overflow: "auto" }}>
              <DataGrid
                loading={loading}
                // rowHeight={40}
                // headerHeight={40}
                rows={filteredInteractions}
                columns={Columns}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                sx={{
                  ...sxStyles.boldHeader,
                  fontSize: "13px",
                  "& .MuiDataGrid-columnHeaders": {
                    fontWeight: "bold",
                    textAlign: "center",
                    // minHeight: "40px !important",
                    // maxHeight: "40px !important",
                  },
                  "& .MuiDataGrid-cell": {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  },
                }}
              />
            </div>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;

const styles = {
  main_container: {
    display: "flex",
    justifyContent: "space-between",
    height: "91vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
    // border:"1px solid red"
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "6px 10px",
  },

  logo_card: {
    width: "18%",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    borderRadius: "12px",
  },
  papercss: {
    textAlign: "left",
    // heignt: "250px",
    // width: "100%",
    color: "white",
    fontSize: "17px",
    fontWeight: "bold",
    // border:"1px solid red",
    padding: "12px",
    marginBottom: "8px",
    marginTop: "0px",
    backgroundColor: "#223d6c",
  },
  partners_logo: {
    width: 46,
    height: 46,
    background: "#66ccff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "10px",
  },
};
